/** Formats a points amount for display, e.g. `1200` → `"1,200 pts"`. */
export const formatPoints = (points: number): string => `${points.toLocaleString()} pts`;
